module.exports = __webpack_public_path__ + "img/img8.811884fa.svg";